// extracted by mini-css-extract-plugin
export default {"button":"style_button__dgwSq","slider":"style_slider__ZEd2R","el":"style_el__j+5Gt","perspectiveText":"style_perspectiveText__4pEYp"};